"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributorsTab = void 0;
const router_1 = require("client/components/router");
const edit_distributor_1 = require("client/modules/sites/modules/sites-detail/components/edit-distributor");
const store_1 = require("client/modules/sites/modules/sites-detail/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
let DistributorsTab = class DistributorsTab extends react_1.Component {
    constructor() {
        super(...arguments);
        this.order = "ASC";
        this.orderBy = "package";
        this.filterText = "";
        this.loadSiteDistributors = () => {
            const options = {
                count: 100,
                order: this.order,
                search: this.filterText,
                start: 0,
                where: "",
                sort: this.orderBy,
                siteId: Number(this.props.params[0])
            };
            store_1.sitesDetailStore.loadSiteDistributors(options);
        };
        this.handleSubmit = async (site, siteDistributors) => {
            // pass data to server to save
            await store_1.sitesDetailStore.saveSiteDistributors(site, siteDistributors);
            this.loadSiteDistributors();
        };
        this.handleCancel = () => {
            router_1.RouteManager.transitionTo("/pharmacies");
        };
    }
    componentDidMount() {
        this.loadSiteDistributors();
    }
    render() {
        const siteId = Number(this.props.params[0]);
        return (React.createElement("div", { className: "patients__form" },
            React.createElement(edit_distributor_1.EditDistributor, { error: store_1.sitesDetailStore.siteDistributors.error, loading: store_1.sitesDetailStore.siteDistributors.loading, site: siteId ? store_1.sitesDetailStore.site.value : null, siteId: siteId, status: store_1.sitesDetailStore.siteDistributors.status, onSave: this.handleSubmit, onCancel: this.handleCancel })));
    }
};
__decorate([
    mobx_1.observable
], DistributorsTab.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], DistributorsTab.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], DistributorsTab.prototype, "filterText", void 0);
DistributorsTab = __decorate([
    mobx_react_1.observer
], DistributorsTab);
exports.DistributorsTab = DistributorsTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/tabs/distributors/distributors.tsx
// module id = 4025
// module chunks = 0